export default __webpack_public_path__ + "static/media/chat_image.0fe79a57.svg";